'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = get;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function get(object, key) {
  if (!object || (typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) !== 'object') return null;
  var value = object[key];

  for (var _len = arguments.length, keys = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    keys[_key - 2] = arguments[_key];
  }

  if (keys.length === 0) return value;
  return get.apply(undefined, [value].concat(keys));
}